/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { setupOfflineSupport } from "utils/offlineSupport";
import { hydrateStoredSession } from "utils/userIdentity";
import { registerServiceWorker } from "./serviceWorkerRegistration";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";

const bootstrap = async () => {
  try {
    await hydrateStoredSession();
  } catch (error) {
    console.warn("Unable to hydrate stored session", error);
  }

  setupOfflineSupport();

  const container = document.getElementById("app");
  if (!container) {
    console.error('Unable to find root container element "#app"');
    return;
  }
  const root = createRoot(container);

  root.render(
    <BrowserRouter>
      <MaterialUIControllerProvider>
        <App />
      </MaterialUIControllerProvider>
    </BrowserRouter>
  );

  registerServiceWorker();
};

bootstrap();
